module.exports = __webpack_public_path__ + "img/page3-3.33a1bcdf.png";